import React, { useEffect, useState } from 'react';
import { Form, Input, Row, Col, Modal, Button, Space, Select } from 'antd';
import { getSpaceUrl } from 'utils/api';
import GridLayout from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

const backgroundImageUrl = getSpaceUrl() + `prison.jpg`;

const EditRoomOnMapModal = (props) => {
  const { t } = useTranslation();
  const [layout, setLayout] = useState([]);
  const [rooms, setRooms] = useState(props.rooms);
  const [dragable, setDragable] = useState(true);
  const [selectedRoomId, setSelectedRoomId] = useState(null);

  const handleUpdate = () => {
    props.action(layout);
  };

  const addToMap = () => {
    if (selectedRoomId) {
      const updatedRooms = _.map(rooms, (room) => {
        if (room.ID === selectedRoomId && room.x == null) {
          return { ...room, x: 1, y: 1, w: 20, h: 8 };
        }
        return room;
      });

      setRooms(updatedRooms);
      const selectedRoom = _.find(rooms, { ID: selectedRoomId });
      if (selectedRoom) {
        const newLayoutItem = {
          x: 0,
          y: 0,
          w: 10,
          h: 5,
          i: selectedRoomId.toString(),
        };
        setLayout((prevLayout) => [...prevLayout, newLayoutItem]);
      }
    }
  };

  const initialLayout = props.rooms
    .filter((room) => room.x !== null && room.y !== null && room.w !== null && room.h !== null)
    .map((room) => ({
      i: `${room.ID.toString()}`,
      x: room.x,
      y: room.y,
      w: room.w,
      h: room.h,
    }));

  const removeStyle = {
    position: 'absolute',
    right: '2px',
    top: 0,
    zIndex: 999,
    cursor: 'pointer',
  };

  const onLayoutChange = (currlayout) => {
    const newLayout = currlayout.map((room) => ({
      ID: room.i,
      x: room.x,
      y: room.y,
      w: room.w,
      h: room.h,
    }));
    setLayout(newLayout);
  };

  const onRemoveItem = (id) => {
    const updatedRooms = _.map(rooms, (room) => {
      if (room.ID === id) {
        return { ...room, x: null, y: null, w: null, h: null };
      }
      return room;
    });
    setRooms(updatedRooms);
    setDragable(true);
  };

  return (
    <Modal
      title={t('rooms.editMap')}
      open={true}
      onOk={handleUpdate}
      onCancel={props.close}
      width="fit-content"
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Row gutter={[16, 16]} style={{ alignItems: 'center' }}>
          <Col sm={24} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <GridLayout
              className="grid-layout"
              style={{
                backgroundImage: `url(${backgroundImageUrl})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '700px 500px',
              }}
              layout={initialLayout}
              cols={100}
              autoSize={false}
              rowHeight={2}
              width={700}
              onLayoutChange={onLayoutChange}
              verticalCompact={false}
              isDraggable={dragable}
              preventCollision={true}
            >
              {rooms
                .filter((room) => room.x !== null && room.y !== null && room.w !== null && room.h !== null)
                .map((room) => (
                  <div key={room.ID.toString()} className="grid-item">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                      <span className="text">{room.ROOM_NAME}</span>
                      <span
                        className="remove"
                        style={removeStyle}
                        onClick={() => onRemoveItem(room.ID)}
                        onMouseEnter={() => setDragable(false)}
                        onMouseLeave={() => setDragable(true)}
                      >
                        x
                      </span>
                    </div>
                  </div>
                ))}
            </GridLayout>
          </Col>
          <Col sm={24}>
            <Space style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {rooms.length !== layout.length && (
                <>
                  <Select
                    value={selectedRoomId}
                    onChange={(value) => setSelectedRoomId(value)}
                    style={{ width: 200, marginBottom: 16 }}
                    placeholder={t('rooms.selectRoom')}
                  >
                    {rooms
                      .filter((room) => room.x === null && room.y === null && room.w === null && room.h === null)
                      .map((room) => (
                        <Select.Option key={room.ID.toString()} value={room.ID}>
                          {room.ROOM_NAME}
                        </Select.Option>
                      ))}
                  </Select>
                  <Button type="primary" size="large" onClick={addToMap}>
                    {t('Add')}
                  </Button>
                </>
              )}
            </Space>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default EditRoomOnMapModal;
